import React from "react";

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlayersStatisticsTableRowValueViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/values/players-statistics.table.row.value.view-model";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";
// import {BoxScoresWidgetTableStatsCellsValue} from "./box-scores-widget.table-stats.cells.value";
import {BoxScoresWidgetTableStatsCellsValues} from "./box-scores-widget.table-stats.cells.values";

class BoxScoresWidgetTableStatsValuesProps extends BaseProps {
  values: Array<PlayersStatisticsTableRowValueViewModel>;
  className: String;
  emptyCell: String;
  showAllStats: Boolean;
  shouldRenderEmptyState: Boolean;
  emptyStateText: String;
  rowNum: Number;
}

export const BoxScoresWidgetTableStatsCells = (({shouldRenderEmptyState, emptyStateText, values, rowNum, className, emptyCell, isGroupedColumn}: BoxScoresWidgetTableStatsValuesProps) => {
  return (
    <div className={classnames(styles.table_row, className)}>
      {
        shouldRenderEmptyState ?
          <div className={classnames(styles.did_not_play_empty_state)}>{emptyStateText}</div> :
          isGroupedColumn ? values?.map((valuesGroup, index) => <div key={index} className={classnames(className, styles.grouped_values)} ><BoxScoresWidgetTableStatsCellsValues values={valuesGroup} emptyCell={emptyCell} className={className}/></div>) :
              <BoxScoresWidgetTableStatsCellsValues values={values} emptyCell={emptyCell} rowNum={rowNum} className={className}/>
      }
    </div>
  )
});
